module.exports = __webpack_public_path__ + "img/hrapp-logo.7206ee29.webp";